
const firstVisited = async () => {
    let todayDate = new Date().toISOString()
    let date = localStorage.getItem('firstVisitedDate');
    if(date===null || date===undefined){
        localStorage.setItem('firstVisitedDate', todayDate);
    }
    return todayDate
};
export default firstVisited;